<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Ticket History</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Support Ticket</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" v-if="has_permission === true">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="card-header">
                <!-- <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i
                    class="fa fa-filter"></i>Filter</a> -->
                <h3 class="card-title">Ticket History</h3>
                <div class="card-tools">
                  <!-- <button class="btn btn-info" @click="exportFile()">
                      <i class="fas fa-download"></i> Export
                    </button> -->
                </div>
              </div>
              <form @submit.prevent="getUsers" method="GET" novalidate>
                <div class="card-body" v-if="showFilter">
                  <div class="form-row">
                    <div class="col-md-6">
                      <!-- Date range -->
                      <div class="form-group form-row">
                        <label class="col-md-3 col-form-label" for="created_at">Date range</label>
                        <div class="col-md-9">
                          <date-picker type="datetime" input-class="form-control" v-model="filter.created_at" range
                            lang="en" format="YYYY-MM-DD hh:mm:ss" confirm id="created_at"
                            value-type="YYYY-MM-DD hh:mm:ss"></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-9 offset-md-3">
                          <button type="submit" class="btn btn-common m-2px">
                            <i class="fas fa-search"></i> Search
                          </button>
                          <button type="reset" class="btn btn-warning" @click="resetFilter()">
                            <i class="fas fa-undo"></i> Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="overlay" v-if="list.is_loading">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
              </div>
              <div class="card-body p-0">
                <div class="table-responsive">
                  <table class="table common-table">
                    <thead>
                      <tr>
                        <th class="col-md-2">ID</th>
                        <th class="col-md-6">Subject</th>
                        <th class="col-md-2">Last Update</th>
                        <th class="col-md-2 text-right">Status</th>
                      </tr>
                    </thead>
                    <tbody class="users-list">
                      <router-link v-for="(val, index) in list.data" :key="index" tag="tr" class="ticket-list-link" :to="{
                        name: 'ticket-details',
                        params: { id: val.id },
                      }">
                        <td>
                          {{ "#" + val.id }}
                          <i class="fas fa-arrow-circle-down"></i>
                        </td>
                        <td>
                          {{ !_.isEmpty(val.subject) ? val.subject : "" }}
                        </td>
                        <td class="text-left">{{ val.lastUpdate }}</td>
                        <td class="text-right">
                          <span :class="[val.className]">{{
                            !_.isEmpty(val.status) ? val.status : "NA"
                          }}</span>
                        </td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <div class="p-4" v-if="_.isEmpty(list.data) && !list.is_loading">
                  <div class="alert alert-default-warning" role="alert">
                    No data found!
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getTicketList()" />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card ticket-intro">
              <div class="card-header">
                <h3 class="card-title">Open new ticket</h3>
              </div>
              <div class="card-body">
                <p>
                  This private ticketing system is developed to handle queries
                  &amp; complain of our direct customers.
                </p>
                <div class="d-flex justify-content-between">
                  <router-link :to="{ name: 'open-ticket' }" class="btn btn-dark-blue">
                    Open New Ticket
                  </router-link>
                  <a class="btn btn-help"
                  href="javascript:void(0);"
                  @click.prevent="goToHelp">Get help</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>
<style scoped>
.closed,
.pending,
.open,
.in-progress {
  border-radius: 100px;
  text-align: center;
  padding: 4px 10px 4px;
  display: inline-block;
  font-size: 13px;
}

span.closed {
  color: #16a085;
  background-color: #e1f9f4;
  border-color: #e1f9f4;
}

span.pending {
  color: #f1711d;
  background-color: #ffe9dd;
  border-color: #ffe9dd;
}

span.open {
  color: #2980b9;
  background-color: #e4f4ff;
  border-color: #e4f4ff;
}

span.in-progress {
  color: #efb548;
  background-color: #fbeacb;
  border-color: #fbeacb;
}
</style>
<script>
import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI, SelfcareAPI } from "@/services/api";
const fileDownload = require("js-file-download");
import { Notification } from "element-ui";

export default {
  name: "TicketHistory",
  metaInfo: {
    title: "Ticket History",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },

  data: () => ({
    list: {
      is_loading: true,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: "asc",
    api_url: "",
    showFilter: false,
    filter: {},
    dateRange: "",
    pre: [],
    is_loading: false,
    has_permission: true,
    helpUrl: '#',
    companyName: process.env.VUE_APP_COMPANY_NAME || '',
  }),
  // method is called after page load
  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }

      // window.$(document).find('.push-menu-class').trigger('click');
    }

    this.companyName = process.env.VUE_APP_COMPANY_NAME || '';
    
    this.api_url = "/ticketList";
    this.getTicketList();
    // this.getOrganization();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
      this.getTicketList();
    });
  },

  metaInfo() {
    return {
      title: this.companyName
        ? `Ticket History | ${this.companyName}`
        : "Ticket History",
    };
  },

  methods: {
    goToHelp: function () {
      let selfCareHelpLink = process.env.VUE_APP_HELP_BASE_URL || '#';
      selfCareHelpLink = this.cleanWebLink(selfCareHelpLink);
      // window.open(selfCareHelpLink, "_blank");
      window.open(selfCareHelpLink, "_blank", "noopener,noreferrer");
    },
    cleanWebLink(link) {
      console.log("Input Link", link);
      link = link.replace(/^['"]+|['";]+$/g, '');
      console.log("Modified Link", link);
      return link;
    },
    exportFile: function () {
      this.is_loading = true;

      axios
        .get("/admin-users-export", { responseType: "blob" })
        .then((response) => {
          //console.log(response.data);
          fileDownload(response.data, "admin-users.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Export Completed",
            message: "Export operation completed successfully",
            type: "success",
          });
        });
    },

    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD hh:mm:ss");
    },

    getTicketList() {
      let _this = this;
      _this.list.is_loading = true;
      let query = { ...this.filter, ...this.$route.query };

      _this.list.data = [
        // {
        //   subject: "#92762990 Get A Call Back", lastUpdate: '12/02/2022', status: 'Open'
        // },
      ];

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      // query.cuid = subscriber.id;

      SelfcareAPI.getSubscriberTickets({})
        .then((response) => {
          console.log("Response Data::", response);
          response.data = response.data.length > 0
            ? response.data.map((o) => {
              o.lastUpdate = moment(o.updated_at).format("DD MMM YYYY");
              o.subject = o.title;
              let state =
                o.ticket_state && o.ticket_state.states
                  ? o.ticket_state.states
                  : "";
              let state_names = state.split(/[ ,]+/);
              let className =
                state_names.length > 0
                  ? state_names.join("-").toLowerCase()
                  : "";
              o.className = className;
              o.status =
                o.ticket_state && o.ticket_state.states
                  ? o.ticket_state.states
                  : "NA";
              return o;
            })
            : [];
          //  console.log("data::", data)
          response.data.length > 0
            ? response.data.sort((a, b) => {
              return moment(b.updated_at) - moment(a.updated_at);
            })
            : [];

          _this.list.is_loading = false;
          _this.list = response;
        })
        .catch((error) => {
          _this.list.is_loading = false;
        })
        .finally(() => {
          _this.list.is_loading = false;
        });

      //this.apiUsage(query);
    },

    apiUsage(query = null) { },

    resetFilter() {
      const query = Object.assign({}, this.$route.query);
      if (Object.keys(query).length > 0) {
        delete query.order_by;
        delete query.order_key;
        delete query.page;
        // Object.keys(query).forEach((key) => delete query.key);
        this.$router.replace({ query });
      }
      this.filter = {};
      this.getTicketList();
    },
  },
};
</script>
